export const gnistaPrimaryColors = {
  main: "#8b9c8e",
  mainText: "#000000",
  secondaryText: "#ffffff",
  stepperText: "#ffffff",
  buttonText: "#ffffff",
  icon: "#bd9279",
  iconBg: "#2b6777",
  background: "#f2ece1",
  additionalInfo: "#018786",
  totalPrice: "#00384a",
  button: "#00384a",
  addButton: "#687b69",
  decButton: "#00384a",
  qtyBackground: "#ffffff",
  cartIconEmpty: "#bd9279",
  cartIconFilled: "#687b69",
  cartIconBackground: "#f2ece1",
  cartBadge: "#b30000",
  cartBackground: "#ffffff",
  cartBorders: "#687b69",
  dateRangeBgFrom: "#00384a",
  dateRangeBgTo: "#bd9279",
  dateRangeBgComplete: "#687b69",
  dateRangeTitle: "#ffffff",
  dateRangeBg: "#d2ccc5",
  providerSelectBg: "#d2ccc5",
  divider: "#687b69",
  productCardBg: "transparent",
  dialogBackground: "#f2ece1",
  skeletonBg: "#1d1d1d",
  skeletonContent: "#ffffff",
  filterSelected: "#f1d7ab",
  filterOption: "#bd9279",
  extraFields: "#808080",
  rescheduleAlert: "#c8d5e4",
};

export const gnistaSecondaryColors = {
  main: "#687b69",
  stepper: "#f2ece1",
  stepperText: "#000000",
  stepperIndicatorText: "#ffffff",
  background: "#d2ccc5",
  filterBackground: "#292929",
  text: "#bd9279",
};

export const scandiaPrimaryColors = {
  main: "#e40523",
  mainText: "#000000",
  secondaryText: "#ffffff",
  divider: "#ffffff",
  stepperText: "#ffffff",
  buttonText: "#ffffff",
  icon: "#012659",
  iconBg: "#2b6777",
  background: "#ffffff",
  additionalInfo: "#148e2a",
  totalPrice: "#012659",
  button: "#2c3070",
  addButton: "#148e2a",
  decButton: "#2c3070",
  qtyBackground: "#F4F4F4",
  cartIconEmpty: "#012659",
  cartIconFilled: "#528d36",
  cartIconBackground: "#ffffff",
  cartBadge: "#b30000",
  cartBackground: "#ffffff",
  cartBorders: "#012659",
  dateRangeBgFrom: "#0454c2",
  dateRangeBgTo: "#012659",
  dateRangeBgComplete: "#148e2a",
  dateRangeTitle: "#000000",
  dateRangeBg: "#ffffff",
  providerSelectBg: "#ffffff",
  productCardBg: "transparent",
  dialogBackground: "#ffffff",
  filterSelected: "#012659",
  filterOption: "#808080",
  extraFields: "#808080",
  rescheduleAlert: "#c8d5e4",
  serviceProviderBg: "#ffffff",
  stepperBg: "#e40523",
  stepperBgActive: "#FAFAFA",
  stepperUnactiveText: "#ffffff",
  stepperInactiveAvatar: "#ffffff",
  stepperActiveValue: "#ffffff",
  stepperInactiveValue: "#e40523",
  stepperActiveText: "#e40523",
  stepperInactiveText: "#ffffff",
  stepperCompleted: "#ffffff",
  reservedButtonColor: "#e40523",
  mobileStepper: "#ffffff",
  mobileStepperProgress: "#ffffff",
};

export const scandiaSecondaryColors = {
  main: "#528d36",
  reservedButtonColor: "#528d36",
  stepper: "#e40523",
  stepperText: "#000000",
  stepperIndicatorText: "#ffffff",
  // filters, sorting
  background: "#ffffff",
  filterBackground: "#292929",
  text: "#808080",
  serviceProviderBg: "transparent",
};
